export class EscapeHtml {
    constructor(html) {
        this.html = html;
    }
    getEscaped() {
        this.html = this.html.replace("&", "&amp;");
        this.html = this.html.replace(/"/, "&quot;");
        this.html = this.html.replace("<", "&lt;");
        this.html = this.html.replace(">", "&gt;");
        return this.html;
    }
}

export class UnescapeHtml {
    constructor(html) {
        this.html = html;
    }
    getUnescaped() {
        this.html = this.html.replace("&amp;", "&");
        this.html = this.html.replace("&quot;", /"/);
        this.html = this.html.replace("&lt;", "<");
        this.html = this.html.replace("&gt;", ">");
        return this.html;
    }
}


// WEBPACK FOOTER //
// ./src/helper/HtmlEscapeUnescape.js